import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PaymentGatewayService } from "../../shared/services/payment-gateway/payment-gateway.service";
import { first } from "rxjs/operators";
import { AlertService } from "../../shared/services/alert/alert.service";

@Component({
  selector: "app-payment-gateway",
  templateUrl: "./payment-gateway.component.html",
  styleUrls: ["./payment-gateway.component.scss"],
})
export class PaymentGatewayComponent implements OnInit {
  form: FormGroup;
  sender: string = "Payment";
  toggleCcavenureForm: boolean = false;
  toggleRazorpayForm: boolean = false;
  initialData: any = {};
  @Input() language: any;

  constructor(
    private gatewayApi: PaymentGatewayService,
    private alertService: AlertService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      hdfcpay: this.fb.group({
        selected: false,
        env: "uat",

        uat: this.fb.group({
          merchant_id: ["", Validators.required],
          access_code: ["", Validators.required],
          key_id: ["", Validators.required],
          url: ["", Validators.required],
          status_url: ["", Validators.required],
          name: ["", Validators.required],
          response_url: ["", Validators.required],
          redirect_url: ["", Validators.required],
        }),

        live: this.fb.group({
          merchant_id: ["", Validators.required],
          access_code: ["", Validators.required],
          key_id: ["", Validators.required],
          url: ["", Validators.required],
          status_url: ["", Validators.required],
          name: ["", Validators.required],
          response_url: ["", Validators.required],
          redirect_url: ["", Validators.required],
        }),
      }),

      razorpay: this.fb.group({
        selected: false,
        env: "uat",
        uat: this.fb.group({
          key_id: ["", Validators.required],
          key_secret: ["", Validators.required],
          merchant_name: ["", Validators.required],
          redirect_url: ["", Validators.required],
        }),

        live: this.fb.group({
          key_id: ["", Validators.required],
          key_secret: ["", Validators.required],
          merchant_name: ["", Validators.required],
          redirect_url: ["", Validators.required],
        }),
      }),
    });
    
    this.getAllPaymentGateways();
  }

  saveEnv(gateway: string, env: string) {
    // const data = this.form.get([gateway, env]).value;
    const gatewayDetials = this.form.get([gateway]).value;
    // console.log(`${gateway} (${env}) saved:`, {
    //   ...gatewayDetials, gateway
    // });
    
    this.gatewayApi
      .updatePaymentGateway({
        ...gatewayDetials, gateway
      })
      .pipe(first())
      .subscribe((res: any) => {
        this.alertService.show(
          this.sender,
          `Payment gateway ${gateway} Selected`,
        );
      });
    // Call your API according to selection
  }

  updatePaymentGateway(gateway: string) {
    this.gatewayApi
      .updatePaymentGateway({ paymentEngine: gateway })
      .pipe(first())
      .subscribe((res: any) => {
        this.alertService.show(
          this.sender,
          `Payment gateway ${gateway} Selected`,
        );
      });
  }
  
  getAllPaymentGateways() {
    this.gatewayApi
      .getPaymentGateway()
      .pipe(first())
      .subscribe((res: any) => {
        this.initialData = res;
        this.initialData.forEach((data) => {
          // Correctly patch nested form with server data
          if (data.gateway === 'razorpay') {
            this.form.get('razorpay').patchValue({
              selected: data.selected,
              env: data.env,
              uat: {
                key_id: data.uat.key_id,
                key_secret: data.uat.key_secret,
                merchant_name: data.uat.merchant_name,
                redirect_url: data.uat.redirect_url,
              },
              live: {
                key_id: data.live.key_id,
                key_secret: data.live.key_secret,
                merchant_name: data.live.merchant_name,
                redirect_url: data.live.redirect_url,
              }
            });
          }
  
          if (data.gateway === 'hdfcpay') {
            this.form.get('hdfcpay').patchValue({
              selected: data.selected,
              env: data.env,
              uat: {
                merchant_id: data.uat.merchant_id,
                access_code: data.uat.access_code,
                key_id: data.uat.key_id,
                url: data.uat.url,
                status_url: data.uat.status_url,
                name: data.uat.name,
                response_url: data.uat.response_url,
                redirect_url: data.uat.redirect_url,
              },
              live: {
                merchant_id: data.live.merchant_id,
                access_code: data.live.access_code,
                key_id: data.live.key_id,
                url: data.live.url,
                status_url: data.live.status_url,
                name: data.live.name,
                response_url: data.live.response_url,
                redirect_url: data.live.redirect_url,
              }
            });
          }
        });
      });
  }

  
  toggleForm(propName: string, value: any) {
    (this as any)[propName] = value;
  }
}
